export const WelcomeStepNutrition = {
  transclude: true,

  bindings: {
    isLoading: '<',
    isShowModal: '<',
    member: '<',
    scrollTo: '&',
    onSubmit: '&',
    onUpdate: '&',
  },

  template: `
    <div class="welcome-step-nutrition">
      <h1 class="h2 text-center text-white my-4">
        Your Nutrition Profile
      </h1>
      <section class="theme-light p-3 mb-5">
        <form class="voome-form"
          name="form"
          ng-submit="$ctrl.onSubmit({ data: $ctrl.member })"
          novalidate>
          <speech-bubble-nutrition
            form="form"
            member="$ctrl.member"
            scroll-to="$ctrl.scrollTo({ id: id })"
            on-complete="$ctrl.isComplete = true"
            on-update="$ctrl.onUpdate({ key: key, value: value })">
          </speech-bubble-nutrition>
          <div class="d-flex justify-content-center pt-4"
            ng-show="$ctrl.isComplete">
            <ng-transclude></ng-transclude>
          </div>
        </form>
      </section>
      <modal-popup
        size="lg"
        ng-if="$ctrl.isShowModal">
        <modal-body>
          <div class="p-3">
            <div class="meal-plan-day-icon icon-lg text-center">
              <i class="icon-recipes text-white fa-3x"></i>
            </div>
            <h3 class="text-center mt-3">Welcome to Voome Nutrition!</h3>
            <p class="text-center mb-0">
              To get you started we have a few questions about your dietary preferences.
            </p>
          </div>
        </modal-body>
      </modal-popup>
    </div>`,
};



// WEBPACK FOOTER //
// ./src/components/WelcomeSteps/WelcomeStepNutrition.js